import React, { useState, useEffect } from 'react';
import { getTestimonials } from '../services/api';
import { Star, Quote, Loader2 } from 'lucide-react';

const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const data = await getTestimonials();
        setTestimonials(data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load testimonials');
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  if (loading) {
    return (
      <section id="testimonials" className="section-spacing bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <Loader2 className="w-12 h-12 animate-spin mx-auto accent-gold" />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="testimonials" className="section-spacing bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-destructive">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section id="testimonials" className="section-spacing bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-serif font-semibold text-foreground mb-6">
            Why Women Love Waisted Momma
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            Real stories from real women who've discovered confidence and empowerment
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className="testimonial-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Quote icon */}
              <div className="mb-4">
                <Quote className="w-10 h-10 accent-gold opacity-30" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, idx) => (
                  <Star key={idx} className="w-5 h-5 fill-accent-gold text-accent-gold" />
                ))}
              </div>

              {/* Testimonial text */}
              <p className="text-base text-foreground font-sans leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="pt-4 border-t border-border">
                <p className="font-sans font-semibold text-foreground">{testimonial.name}</p>
                <p className="font-sans text-sm text-muted-foreground">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social proof section */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-8 bg-blush rounded-2xl px-8 py-6 shadow-md">
            <div className="text-center">
              <p className="text-4xl font-serif font-semibold text-foreground">10,000+</p>
              <p className="text-sm font-sans text-muted-foreground">Happy Customers</p>
            </div>
            <div className="hidden sm:block w-px h-12 bg-border"></div>
            <div className="text-center">
              <p className="text-4xl font-serif font-semibold text-foreground">4.9/5</p>
              <p className="text-sm font-sans text-muted-foreground">Average Rating</p>
            </div>
            <div className="hidden sm:block w-px h-12 bg-border"></div>
            <div className="text-center">
              <p className="text-4xl font-serif font-semibold text-foreground">98%</p>
              <p className="text-sm font-sans text-muted-foreground">Recommend Us</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
